import { MRT_Row } from "material-react-table"
import { ProductDto } from "@custom-types/products"
import { Icon } from "@mui/material"
import CheckIcon from "@mui/icons-material/Check"
import CloseIcon from "@mui/icons-material/Close"

export const getMaterialTableColumns = () => [
  {
    accessorKey: "name",
    header: "Name",
    size: 300,
  },
  {
    accessorKey: "organisation_key",
    header: "Organisation",
  },
  {
    accessorKey: "division_key",
    header: "Division",
    size: 200,
  },
  {
    accessorKey: "is_external",
    header: "External",
    type: "boolean",
    size: 75,
    Cell: ({ row }: { row: MRT_Row<ProductDto> }) => (
      <Icon fontSize="small">{row.original.is_external ? <CheckIcon /> : <CloseIcon />}</Icon>
    ),
  },
  {
    accessorKey: "active",
    header: "Active",
    type: "boolean",
    size: 75,
    Cell: ({ row }: { row: MRT_Row<ProductDto> }) => (
      <Icon fontSize="small">{row.original.active ? <CheckIcon /> : <CloseIcon />}</Icon>
    ),
  },
]
